import React, { useState } from "react";
import { IVideoData } from "../../exports/interfaces";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import DynamicToolTip from "../DynamicToolTip";
import { useLoader } from "../../context/LoaderContext";
import { Fade } from "react-awesome-reveal";

const ArchiveVideos = (props: { archiveVideoData: IVideoData[] }) => {
  const { loading } = useLoader();
  // const groupedData = props.archiveVideoData.reduce((acc, item) => {
  //   const doctor = item.attributes.Doctor_Name;

  //   const existingDoctor = acc.find((name) => name.doctor === doctor);

  //   if (existingDoctor) {
  //     existingDoctor.data.push(item);
  //   } else {
  //     acc.push({ doctor, data: [item] });
  //   }

  //   return acc;
  // }, [] as { doctor: string; data: typeof props.archiveVideoData }[]);
  const [open, setOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState<string | null>(null);
  const handleVideoClick = (url: string) => {
    setVideoUrl(url);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setVideoUrl(null);
  };

  return (
    <>
      {/* <section className="volunteers-one" style={{ padding: "90px 0 90px" }}>
        <div className="container">
          <div className="section-title text-center">
              <h2 className="section-title__title">{group.doctor}</h2>
              </div>
          <div className="row">
            {props.archiveVideoData?.map((group) => (
              <div className="col-xl-3 col-lg-4 col-md-6" key={group.id}>
                <div className="tab-content__inner-right ">
                  <div className="tab-content__video-link">
                    <div
                      className="tab-content-video-bg"
                      style={{
                        backgroundImage: `url(${process.env.REACT_APP_strapiUrl}${group?.attributes?.Thumbnail?.data?.attributes?.url})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    ></div>
                    <div
                      onClick={() =>
                        handleVideoClick(
                          `${process.env.REACT_APP_strapiUrl}${group?.attributes?.Video?.data?.attributes?.url}`
                        )
                      }
                      className="video-popup"
                      style={{ cursor: "pointer" }}
                    >
                      <div className="tab-content__video-icon">
                        <span className="fa fa-play"></span>
                        <i className="ripple"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}
      <section className="events-page">
        <div className="container">
          <div className="row">
            {!loading &&
              props.archiveVideoData?.map((group, index) => (
                <div className="col-xl-3 col-lg-6 col-md-6" key={group.id}>
                  <Fade
                    key={index}
                    cascade
                    damping={0.2}
                    triggerOnce={true}
                    delay={index * 200}
                  >
                    <div className="events__single">
                      <div className="custom-vid-div">
                        <div
                          className="tab-content-video-bg"
                          style={{
                            backgroundImage: `url(${process.env.REACT_APP_strapiUrl}${group?.attributes?.Thumbnail?.data?.attributes?.url})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                          }}
                        ></div>
                        <DynamicToolTip title="Play Video">
                          <div
                            onClick={() =>
                              handleVideoClick(group?.attributes?.Video_Link)
                            }
                            className="video-popup"
                            style={{ cursor: "pointer" }}
                          >
                            <div className="tab-content__video-icon">
                              <span className="fa fa-play"></span>
                              <i className="ripple"></i>
                            </div>
                          </div>
                        </DynamicToolTip>
                      </div>
                      <div className="events__content">
                        <h3
                          className="events__title"
                          style={{ marginBottom: "unset" }}
                        >
                          {group?.attributes?.Video_Title}
                        </h3>
                        <p>{group?.attributes?.Doctor_Name}</p>
                      </div>
                    </div>
                  </Fade>
                </div>
              ))}
          </div>
        </div>
      </section>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            background: "transparent",
            boxShadow: "none",
          },
        }}
      >
        {/* DialogTitle with Close Icon */}
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "8px 0px 8px 8px",
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              color: "#fff",
              padding: '0px'
            }}
          >
            <i className="icon-cross" style={{fontSize: '14px'}}></i>
          </IconButton>
        </DialogTitle>

        {/* Video Content */}
        <DialogContent sx={{ padding: "0px" }}>
          {videoUrl && (
            <iframe
              width="100%"
              height="460dvh"
              src={videoUrl.replace("watch?v=", "embed/").split("&")[0]}
              title="YouTube video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{
                border: "none",
              }}
            ></iframe>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ArchiveVideos;
